import { ReloadOutlined } from "@ant-design/icons";
import { useQueryClient } from "@tanstack/react-query";
import { Button, Tooltip } from "antd";
import { useState } from "react";
import { useI18n } from "@/i18n";

/**
 * "Perbarui": loads the page's data again without reopening the tab or the
 * browser's refresh. Given queryKeys, refetches them; given onRefresh (e.g.
 * read an order again from the marketplace), runs that.
 */
export function RefreshButton({ queryKeys, onRefresh, label }: { queryKeys?: unknown[][]; onRefresh?: () => Promise<unknown>; label?: string }) {
  const { t } = useI18n();
  const queryClient = useQueryClient();
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      if (onRefresh) await onRefresh();
      await Promise.all((queryKeys ?? []).map((queryKey) => queryClient.refetchQueries({ queryKey, type: "active" })));
    } catch {
      // the caller shows its own error
    } finally {
      setBusy(false);
    }
  };
  const button = (
    <Button icon={<ReloadOutlined />} loading={busy} onClick={() => void run()} aria-label={label ?? t("common.refresh")}>
      {label}
    </Button>
  );
  return label ? button : <Tooltip title={t("common.refresh")}>{button}</Tooltip>;
}
